import React from "react";
import ShieldLogo from "@/assets/TransparentLogoIconWhiteShield.png";
import { cn } from "@/lib/utils";

type LogoShieldProps = React.ImgHTMLAttributes<HTMLImageElement>;

export const LogoShield: React.FC<LogoShieldProps> = ({
  className,
  alt = "ShadowScan shield logo",
  ...props
}) => {
  return (
    <img
      src={ShieldLogo}
      alt={alt}
      className={cn("inline-block select-none", className)}
      draggable={false}
      {...props}
    />
  );
};
